import { lte } from '@/services/floatComparison';
import { modelService } from '@/services/form/modelService';
import {
    isPluginGeneratingPlant,
    isPv,
} from '@/services/form/rules/application/common';
import { formatGermanNumber } from '@/utilities/germanFormats';
import { helpers, ValidationRule } from 'vuelidate/lib/validators';

export const maxOverallNominalPowerPlugInGeneratingPlant = (
    max: number,
): ValidationRule => {
    return helpers.withParams(
        {
            type: 'maxOverallNominalPowerPlugInGeneratingPlant',
            max: formatGermanNumber(max, { decimals: 3 }),
        },
        (value: number) => {
            const application = modelService.model.application;
            return (
                !isPluginGeneratingPlant(application) ||
                !isPv(application) ||
                lte(value, max)
            );
        },
    );
};
